import { Species } from '../../api/fishrules/getAllSpeciesAtLocation';

/* Filter species coming from Fishrules API based on provided species External IDs */
export const filterSpeciesByIds = (species: Species, idsFilter?: string[]): boolean => {
  // If no filter provided or empty, include all species
  if (!idsFilter || idsFilter.length === 0) {
    return true;
  }

  // Check if any of the species' fishbrainIds match any ID in speciesIdsFilter
  return species.fishbrain_ids.some(id => idsFilter.includes(id));
};
